<template>
  <b-modal
    id="modal-survey-result-detail"
    size="xl"
    scrollable
    hide-footer
    :title="item ? `${item.fullName || ''} - ${item.surveyName || ''}` : ''"
    @show="loadData"
    @hidden="rows = []"
  >
    <div v-if="item" class="mb-4">
      <span class="mr-6">SĐT: {{ phone }}</span>
      <span>Mã khảo sát: {{ item.surveyCode }}</span>
    </div>

    <div v-if="!loading && !sections.length" class="text-center text-muted py-6">
      Chưa có câu trả lời nào
    </div>

    <!-- Gom câu trả lời theo section, câu hỏi chọn nhiều đáp án thì gộp chung một dòng -->
    <div v-for="section in sections" :key="section.name" class="mb-6">
      <h6 class="section-title">{{ section.name }}</h6>
      <table class="table table-bordered mb-0">
        <thead>
          <tr>
            <th style="width: 35%">Câu hỏi</th>
            <th>Câu trả lời</th>
            <th style="width: 90px" class="text-center">Điểm</th>
            <th style="width: 160px">Ngày làm</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(question, index) in section.questions" :key="index">
            <td>{{ question.questionName }}</td>
            <td>
              <div v-for="(answer, i) in question.answers" :key="i">{{ answer }}</div>
            </td>
            <td class="text-center">{{ question.point }}</td>
            <td>{{ formatDate(question.dateDo) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSurveyResultDetail',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      rows: [],
    };
  },
  computed: {
    phone() {
      const phone = this.item?.phone;
      return phone ? phone.replace('+84', '0') : null;
    },
    sections() {
      const sections = [];
      this.rows.forEach((row) => {
        let section = sections.find((s) => s.name === row.sectionName);
        if (!section) {
          section = { name: row.sectionName, questions: [] };
          sections.push(section);
        }
        let question = section.questions.find((q) => q.questionName === row.questionName);
        if (!question) {
          question = { questionName: row.questionName, answers: [], points: [], dateDo: row.dateDo };
          section.questions.push(question);
        }
        question.answers.push(row.content);
        if (row.point && row.point !== 'Text') question.points.push(Number(row.point));
      });
      sections.forEach((s) =>
        s.questions.forEach((q) => {
          q.point = q.points.length ? q.points.reduce((a, b) => a + b, 0) : null;
        }),
      );
      return sections;
    },
  },
  methods: {
    async loadData() {
      if (!this.item?.accountId || !this.item?.surveyId) return;

      this.loading = true;
      try {
        const { meta, data, error } = await this.$api.get('/Survey/SurveyResultDetail', {
          params: { accountId: this.item.accountId, surveyId: this.item.surveyId },
        });
        if (!meta.success) {
          return this.$toastr.e({ title: 'Lỗi !', msg: error.message });
        }
        this.rows = data || [];
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi !', msg: error.message });
      } finally {
        this.loading = false;
      }
    },
    // BE trả DateTime dạng unix timestamp (giây)
    formatDate(value) {
      return value ? this.convertTimestampToDate(value, 'DD/MM/YYYY HH:mm') : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  color: #01645a;
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
